const configRefund = {
    refund: {
        listLayout: 'RefundListDefaultLayout',
        filterLayout: 'RefundFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getRefund',
        listApiParamSet: {
            type:'basic',
            ip:1,
            sp:10,
        },
    },
   detail:{
       writeLayouts: ['RefundWriteDefaultLayout'],
       getFunc: 'getRefund',
       detailApiParamsSet: {
           type:'basic',
           ip:0,
           sp:10,
       },
       writeFunc: 'updateRefund',
       writeApiParamSet: {
       },
       parsingData: {
           status: 'or_status',
           content: 'or_reply',
       },
       directUrl: '',
       directType: 'back',
       keyName: 'id',
       writeSuccessType: 1,
       writeFailTypes: {},
   },
}

export default {
    methods: {
        returnRefundConfig(type) {
            return configRefund[type];
        }
    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        pgnu: {
            type: 'query',
            classname: 'searchInput',
        },
        oid: {
            type: 'query',
            classname: 'searchInput',
        },
        st:{
            type:'match',
            classname:'filterStatus'
        },
        pg:{
            type:'match',
            classname:'filterPayType'
        },
        cid: {
            type: 'match',
            classname: 'langOption'
        },
    }
}
